import { BaseConfig } from '../ServiceConfig';

export interface DCAConfiguration extends BaseConfig {
  '@type': 'type.googleapis.com/terra.v1.DcaServiceConfigData';
  url: string;
}

export const DCAConfigurationFields: (keyof DCAConfiguration)[] = ['url'];

export const BlankDCAConfiguration: DCAConfiguration = {
  '@type': 'type.googleapis.com/terra.v1.DcaServiceConfigData',
} as DCAConfiguration;
